import { render, staticRenderFns } from "./ProjectFormModal.vue?vue&type=template&id=daaa2ae8&scoped=true"
import script from "./ProjectFormModal.vue?vue&type=script&lang=js"
export * from "./ProjectFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaa2ae8",
  null
  
)

export default component.exports